import { defineStore } from 'pinia';

import { getCityBySlug } from '@/shared/api/experience';
import { useLogger } from '@/shared/utils/logger';

import type { City } from './models';
import { normalizeCity } from './transforms/city';

export const useCityArticlesEntity = defineStore('journal:city-articles:city-articles-entity', {
  state: () => ({
    /**
     * Флаг состояния загрузки.
     */
    isLoading: false,

    /**
     * Флаг, показывающий, что загрузка окончилать неудачей.
     */
    isLoadingFailed: false,

    /**
     * Данные города.
     */
    cityState: null as City | null,
  }),

  getters: {
    /**
     * Флаг состояния загрузки.
     */
    loading: (state) => state.isLoading,

    /**
     * Флаг, показывающий, что загрузка окончилать неудачей.
     */
    loadingFailed: (state) => state.isLoadingFailed,

    /**
     * Данные города.
     */
    city: (state) => state.cityState,
  },

  actions: {
    logger: useLogger,

    /**
     * Загружает базовые данные страницы города.
     *
     * @param citySlug slug города
     * @returns
     */
    async loadPageData(citySlug: string) {
      this.isLoading = true;
      this.isLoadingFailed = false;

      let response;

      try {
        response = await getCityBySlug({ path: { citySlug } });
      } catch (e) {
        this.logger().error('could not load a city data by the reason:', e);
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      if (!response?.data) {
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      this.cityState = normalizeCity(response.data);
      this.isLoading = false;
    },

    /**
     * Сбрасывает состояние сущности.
     */
    reset() {
      this.cityState = null;
      this.isLoading = false;
      this.isLoadingFailed = false;
    },
  },
});
